import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { AppShell } from '@/components/cross/app-shell';
import { RouteFrame } from '@/components/cross/route-frame';

const Home = lazy(() => import('@/pages/home'));
const Trade = lazy(() => import('@/pages/trade'));
const Review = lazy(() => import('@/pages/review'));
const Status = lazy(() => import('@/pages/status'));
const Complete = lazy(() => import('@/pages/complete'));
const Activity = lazy(() => import('@/pages/activity'));
const Lock = lazy(() => import('@/pages/lock'));
const Token = lazy(() => import('@/pages/token'));
const Profile = lazy(() => import('@/pages/profile'));
const Security = lazy(() => import('@/pages/security'));
const Docs = lazy(() => import('@/pages/docs'));

function NotFound() {
  return <div className="page"><div className="mx-auto mt-24 max-w-lg text-center"><div className="eyebrow">404</div><h1 className="page-title mt-3">Route not found</h1><a href="/" className="mt-5 inline-block text-sm text-mint">Return to CROSS</a></div></div>;
}

function RouteLoading() {
  return <div className="page" aria-live="polite"><div className="h-1 w-24 overflow-hidden rounded-full bg-[#10281f]"><span className="skeleton block h-full w-full" /></div><span className="sr-only">Loading page</span></div>;
}

function LegacyRedirect({ to }: { to: string }) {
  const location = useLocation();
  return <Navigate replace to={`${to}${location.search}${location.hash}`} />;
}

export default function App() {
  return <Routes><Route element={<AppShell />}><Route element={<Suspense fallback={<RouteLoading />}><RouteFrame /></Suspense>}>
    <Route index element={<Home />} />
    <Route path="token" element={<Token />} />
    <Route path="security" element={<Security />} />
    <Route path="docs" element={<Docs />} />

    <Route path="app" element={<Navigate replace to="/app/trade" />} />
    <Route path="app/trade" element={<Trade />} />
    <Route path="app/trade/review" element={<Review />} />
    <Route path="app/trade/status" element={<Status />} />
    <Route path="app/trade/complete" element={<Complete />} />
    <Route path="app/activity" element={<Activity />} />
    <Route path="app/lock" element={<Lock />} />
    <Route path="app/profile" element={<Profile />} />

    <Route path="trade" element={<LegacyRedirect to="/app/trade" />} />
    <Route path="trade/review" element={<LegacyRedirect to="/app/trade/review" />} />
    <Route path="trade/status" element={<LegacyRedirect to="/app/trade/status" />} />
    <Route path="trade/complete" element={<LegacyRedirect to="/app/trade/complete" />} />
    <Route path="activity" element={<LegacyRedirect to="/app/activity" />} />
    <Route path="lock" element={<LegacyRedirect to="/app/lock" />} />
    <Route path="profile" element={<LegacyRedirect to="/app/profile" />} />
    <Route path="*" element={<NotFound />} />
  </Route></Route></Routes>;
}
